// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const header = "ChartHeader__header__j6uJY";
export const twoRows = "ChartHeader__twoRows__UKwEB";
export const titleBase = "ChartHeader__titleBase__86uxW font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const title = "ChartHeader__title__em4Gf ChartHeader__titleBase__86uxW font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const labelsRow = "ChartHeader__labelsRow__Mgs05";
export const itemsRow = "ChartHeader__itemsRow__HAwtz";
export const secondaryValuesWrapper = "ChartHeader__secondaryValuesWrapper__FhpZu";
export const label = "ChartHeader__label__dP+cB";
export const hideOthers = "ChartHeader__hideOthers__Kf0h5";
export const item = "ChartHeader__item__7sLQP";
export const member = "ChartHeader__member__uhs2C";
export const peers = "ChartHeader__peers__Z8c0s";
export const others = "ChartHeader__others__uP-Dv";
export const itemValue = "ChartHeader__itemValue__-HRlg";
export const secondaryLabelsWrapper = "ChartHeader__secondaryLabelsWrapper__VS0d4";
export const secondaryTitle = "ChartHeader__secondaryTitle__ZMqmH ChartHeader__titleBase__86uxW font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const ctaWrapper = "ChartHeader__ctaWrapper__4Bbnt";